'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _pacomo = require('utils/pacomo');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PassengerList = function PassengerList(_ref) {
    var userCustomerId = _ref.userCustomerId,
        requiredApiCalls = _ref.requiredApiCalls,
        checkinUrlsByCustomerId = _ref.checkinUrlsByCustomerId,
        passengersById = _ref.passengersById,
        requirementSetsByCustomerId = _ref.requirementSetsByCustomerId,
        props = (0, _objectWithoutProperties3.default)(_ref, ['userCustomerId', 'requiredApiCalls', 'checkinUrlsByCustomerId', 'passengersById', 'requirementSetsByCustomerId']);
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _components2.LoadingIndicator,
            { inline: true, apiCalls: requiredApiCalls },
            passengersById && checkinUrlsByCustomerId && (0, _keys2.default)(passengersById).map(function (passengerId, i) {
                var checkinUrl = checkinUrlsByCustomerId[passengerId];
                var passenger = passengersById[passengerId];
                var reqSets = requirementSetsByCustomerId[passenger.id];
                return _react2.default.createElement(_components2.PassengerListItem, {
                    key: i,
                    passengerId: passenger.id,
                    firstName: passenger.name.legal_first_name,
                    lastName: passenger.name.legal_last_name,
                    checkinUrl: checkinUrl,
                    emailAddress: passenger.account_email,
                    isComplete: reqSets.totalReqSets === reqSets.reqSetsComplete,
                    isUserPassenger: userCustomerId === passenger.id,
                    requirementSteps: reqSets.totalReqSets,
                    requirementStepsComplete: reqSets.reqSetsComplete });
            })
        )
    );
};

exports.default = (0, _pacomo.pacomoTransformer)(PassengerList);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/PassengerList/PassengerList.js
// module id = 1307
// module chunks = 0